// extracted by mini-css-extract-plugin
export default {"content":"Home_content__w7cRQ","shimmer":"Home_shimmer__+J0JK"};